'use strict'

CardUI = require 'grpn-card-ui/frontend/init'
{isFeatureEnabled, checkSetting} = require '../helpers/finch'
isScrolledPastElement = require '../helpers/is_scrolled_past_element'
{getParameterByName} = require '../helpers/query_params'

module.exports = class SponsoredDealsView extends Backbone.View
  initialize: (options) ->
    if @_isSearchPage()
      return

    @options = options
    @listenTo @model, 'sync', @_handleSponsoredDealsWidgetResponse
    @load()

  load: ->
    @model.fetch
      data:
        _csrf: @options._csrf

  _handleSponsoredDealsWidgetResponse: ->
    {sponsoredDealsWidgetHtml} = @model.toJSON()

    if sponsoredDealsWidgetHtml?
      @_addSponsoredDealsWidgetScrollListener()
      if checkSetting('showSponsoredDealsWidget')
        @_renderSponsoredDealsElement(sponsoredDealsWidgetHtml)
        CardUI.init('#pull-sponsored-deals-widget')

  _renderSponsoredDealsElement: (sponsoredDealsWidgetHtml) ->
    sponsoredDealsWidgetContainer = document.createElement('div')
    sponsoredDealsWidgetContainer.id = 'pull-sponsored-deals-widget'
    sponsoredDealsWidgetContainer.classList.add('twelve', 'column', 'cui-four-up')
    sponsoredDealsWidgetContainer.setAttribute('data-bhw', 'SponsoredDealsWidget')
    sponsoredDealsWidgetContainer.innerHTML = sponsoredDealsWidgetHtml

    bottomWidget = document.querySelector('#pull-widget')
    bottomWidget.parentNode.insertBefore(sponsoredDealsWidgetContainer, bottomWidget.nextSibling)

  _addSponsoredDealsWidgetScrollListener: ->
    cardContainer = document.querySelector('#pull-widget')

    if isScrolledPastElement(cardContainer)
      isFeatureEnabled('showSponsoredDealsWidget')
    else
      @_handleSponsoredDealsWidgetBucketing = =>
        if isScrolledPastElement(cardContainer)
          isFeatureEnabled('showSponsoredDealsWidget')
          window.removeEventListener('scroll', @_onScrollForSponsoredDealsWidget)

      @_onScrollForSponsoredDealsWidget = _.debounce(@_handleSponsoredDealsWidgetBucketing, 200)
      window.addEventListener('scroll', @_onScrollForSponsoredDealsWidget)

  _isSearchPage: ->
    getParameterByName('query') != null